module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/totes/totes.component.css
// module id = 920
// module chunks = 4